import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../../decorators'
import { getCompanyContactRoleListData } from './mockData'
import type { IContactRole } from '~/types/contact/models'

// get

interface GetCompanyContactRolesResponse {
  data: IContactRole[]
}

async function getCompanyContactRoles(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetCompanyContactRolesResponse = {
    data: await getCompanyContactRoleListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postCompanyContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getCompanyContactRoleListData)
}

const patchCompanyContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCompanyContactRoleListData)
}

const deleteCompanyContactRole = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getCompanyContactRoleListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/companycontactroles',
    handler: getCompanyContactRoles,
  },
  {
    method: 'post',
    path: '/api/companycontactroles',
    handler: postCompanyContactRole,
  },
  {
    method: 'patch',
    path: '/api/companycontactroles/:id',
    handler: patchCompanyContactRole,
  },
  {
    method: 'delete',
    path: '/api/companycontactroles/:id',
    handler: deleteCompanyContactRole,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
